var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-row",
    [
      _c(
        "vs-col",
        { attrs: { id: "list" } },
        [
          _c(
            "vs-table",
            { attrs: { data: _vm.templatesList } },
            [
              _c("template", { slot: "header" }, [
                _c("h3", [_vm._v(" Plantillas creadas ")])
              ]),
              _c(
                "template",
                { slot: "thead" },
                [
                  _c("vs-th", [_vm._v(" Tipo ")]),
                  _c("vs-th", [_vm._v(" Nombre ")]),
                  _c("vs-th", [_vm._v(" Descripción ")]),
                  _c("vs-th", [_vm._v(" Creada ")]),
                  _c("vs-th", [_vm._v(" Estado ")]),
                  _c("vs-th")
                ],
                1
              ),
              _vm._l(_vm.templatesList, function(template) {
                return _c(
                  "vs-tr",
                  { key: template.opcionId },
                  [_c("ListTemplateItem", { attrs: { item: template } })],
                  1
                )
              })
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }